export const DEFAULT_TRANSCRIPTION_LIMIT = 100
export const MIN_TRANSCRIPTION_LIMIT = 1
export const MAX_TRANSCRIPTION_LIMIT = 1000

/** Parses the "max files per run" input; returns null unless it is an integer within the allowed range. */
export function parseTranscriptionLimit(value: string): number | null {
  if (!/^\d+$/.test(value.trim())) return null
  const limit = Number(value)
  return limit >= MIN_TRANSCRIPTION_LIMIT && limit <= MAX_TRANSCRIPTION_LIMIT ? limit : null
}

export function isValidTranscriptionLimit(value: string): boolean {
  return parseTranscriptionLimit(value) !== null
}
